import React from 'react';
import { Table } from 'src/components/matchbox';
import { RECIPIENT_VALIDATION_TIERS } from 'src/constants';
import { formatFullNumber } from 'src/helpers/units';
import styles from './RecipientValidationPriceTable.module.scss';
import { TranslatableText } from '../text';

export const RecipientValidationPriceTable = ({ cellProps, col1Props, col2Props }) => {
  return (
    <Table>
      <tbody>
        <Table.Row className={styles.tableHeader}>
          <Table.Cell {...cellProps} {...col1Props}>
            <strong>Number of Emails</strong>
          </Table.Cell>
          <Table.Cell {...cellProps} {...col2Props}>
            <strong>Cost</strong>
          </Table.Cell>
        </Table.Row>
        {RECIPIENT_VALIDATION_TIERS.map((row, index) => {
          const isFirst = index === 0;
          const isBeyond = row.volumeMax === Infinity;

          return (
            <Table.Row key={`row-${row.volumeMin}-${row.volumeMax}`}>
              <Table.Cell {...cellProps} {...col1Props}>
                {isBeyond ? (
                  <>
                    <TranslatableText>Emails beyond</TranslatableText>{' '}
                    <strong>{formatFullNumber(row.volumeMin)}</strong>
                  </>
                ) : (
                  <>
                    <TranslatableText>{isFirst ? 'First' : 'Next'}</TranslatableText>{' '}
                    <strong>{formatFullNumber(row.volumeMax - row.volumeMin)}</strong>
                  </>
                )}
              </Table.Cell>
              <Table.Cell {...cellProps} {...col2Props}>
                <span>
                  <strong>{row.displayedCost}</strong> per email address
                </span>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </tbody>
    </Table>
  );
};

export default RecipientValidationPriceTable;
